import { LanguageOption } from "@fidget/common/components/form/languagePicker/languagePicker";
import { intl } from "@fidget/common/i18n";
import React from "react";
import styles from "./WithLocaleHeader.css";

interface Props {
  locale: LanguageOption;
}
export const WithLocaleHeader = ({ locale, children }: React.PropsWithChildren<Props>) => {
  const renderLocaleLabel = () => {
    switch (locale) {
      case LanguageOption.Polish:
        return intl.formatMessage("language.polish");
      case LanguageOption.English:
      default:
        return intl.formatMessage("language.english");
    }
  };

  return (
    <div className={styles.container}>
      <p className={styles.label}>{renderLocaleLabel()}</p>
      {children}
    </div>
  );
};
